import { extractParams } from '@zapier/url-utils';

import { HELD_REASONS_QUERY_PARAM } from 'app/history/utils/constants';

export const HOME_FOLDER_ID = 0;
export const TRASH_FOLDER_ID = 'trash';
export const HELD_FOLDER_ID = 'held';

export const virtualFolderIds = [TRASH_FOLDER_ID, HELD_FOLDER_ID];

const urlParams =
  typeof window !== 'undefined' ? extractParams(window.location.href) : {};

const DEBUG_TRASH_DAYS = parseInt(urlParams.DEBUG_TRASH_DAYS);

export const TRASH_DAYS = isNaN(DEBUG_TRASH_DAYS) ? 30 : DEBUG_TRASH_DAYS;

// This is the same shape as real folders that come from the server,
// except no `accountId` is present.
export const homeFolder = {
  id: HOME_FOLDER_ID, // this has been used throughout codebase
  isShared: false,
  title: 'Home',
  isVirtual: true,
  isHeld: false,
  sortOrder: 1,
};

export const heldFolder = {
  id: HELD_FOLDER_ID,
  isShared: false,
  title: 'Zaps with Held Tasks',
  isVirtual: true,
  isHeld: true,
  icon: 'holding',
};

export const trashFolder = {
  id: TRASH_FOLDER_ID,
  isShared: false,
  title: 'Trash',
  isVirtual: true,
  isTrash: true,
  isHeld: false,
  icon: 'trash',
};

export { CREDIT_CARD_URL } from 'app/settings/utils/constants';

export const FOLDER_ID_PARAM = 'folderId';
export const HELD_STATUSES_URL = `/app/history?status=${HELD_REASONS_QUERY_PARAM}`;
export const AUTHS_URL = '/app/connections';
export const PLANS_URL = '/app/settings/billing/plan';
export const UPSELL_TEAM_INVITES_EXPERIMENT = 'upsell-team-invites-e11';
export const SHOW_UPSELL_TEAM_INVITES_VARIANT = 'upsell';
